import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VEHICLE_AS_FIXED_ASSET = {
  YES: 'yes',
  NO: 'no',
  IDK: 'does_not_know',
} as const;

export const VEHICLE_AS_FIXED_ASSET_NAME = 'vehicle_as_fixed_asset';
export const VEHICLE_AS_FIXED_ASSET_NAME_COMPLEMENTARY =
  'vehicle_as_fixed_asset_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupVehicleAsFixedAsset: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? VEHICLE_AS_FIXED_ASSET_NAME_COMPLEMENTARY
      : VEHICLE_AS_FIXED_ASSET_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Czy pojazd jest wprowadzony do działalności jako środek trwały?'
            )}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'vertical'}
              data-testid="radio-group-vehicle-as-fixed-asset"
            >
              <RadioItem
                value={VEHICLE_AS_FIXED_ASSET.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-vehicle-as-fixed-asset-yes"
              />
              <RadioItem
                value={VEHICLE_AS_FIXED_ASSET.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-vehicle-as-fixed-asset-no"
              />{' '}
              <RadioItem
                value={VEHICLE_AS_FIXED_ASSET.IDK}
                label={i18n.t('Nie wiem, zapytam księgową')}
                data-testid="radio-item-vehicle-as-fixed-asset-idk"
              />
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
